import { useFormikContext } from 'formik';
import { get } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { View, Text } from 'react-native';
import { CheckBox } from 'react-native-elements';
import styles from './styles';

type CheckboxProps = {
  name: string;
  label: string;
  optionLabel: string;
};

const CheckBoxField = ({ name, label, optionLabel }: CheckboxProps) => {
  const { handleBlur, setFieldValue, values, errors, touched } =
    useFormikContext();
  const isTouched = useMemo(() => {
    return get(touched, name);
  }, [touched, name]);

  const value = useMemo(() => {
    return get(values, name);
  }, [values, name]);

  const error = useMemo(() => {
    return get(errors, name);
  }, [errors, name]);

  const onPress = useCallback(() => {
    setFieldValue(name, !value);
  }, [value, name, setFieldValue]);
  return (
    <View style={styles.checkboxWrapper}>
      <Text style={styles.labelStyle}>{label}</Text>
      <CheckBox
        onPress={onPress}
        title={optionLabel}
        onBlur={handleBlur(name)}
        checked={value}
        containerStyle={styles.checkboxContainer}
      />
      {/* {isTouched && error && <Text style={styles.error}>{error}</Text>} */}
    </View>
  );
};

export default CheckBoxField;
